import {styled} from '@linaria/react';
import {
  useRive,
  useViewModelInstanceColor,
  useViewModelInstanceString,
} from '@rive-app/react-canvas';
import React, {useEffect} from 'react';
import {COLORS} from '../../../../constants/colors';
import BonusCoinsClaimedRiv from '../assets/bonus_coins_claimed.riv';
import {hexToRiveColorNumber} from '../utils/hexToRiveColorNumber';

export const ClaimCoinsPopupAnimation: React.FC<{
  bonusValue: string;
  bonusDescription: string;
}> = ({bonusValue, bonusDescription}) => {
  const {rive, RiveComponent} = useRive(
    {
      src: BonusCoinsClaimedRiv,
      autoBind: true,
      autoplay: true,
      stateMachines: 'State Machine 1',
    },
    {
      // ensures the canvas matches the device's pixel density
      useDevicePixelRatio: true,
      shouldResizeCanvasToContainer: true,
    },
  );

  const viewModelInstance = rive?.viewModelInstance;

  const {setValue: setCoinsValue} = useViewModelInstanceString(
    'label.coins.value',
    viewModelInstance,
  );

  const {setValue: setDescription} = useViewModelInstanceString(
    'label.coins.title',
    viewModelInstance,
  );

  const {setValue: setBubblesColor} = useViewModelInstanceColor(
    'colors.fill.inactive',
    viewModelInstance,
  );

  const {setValue: setCardColor} = useViewModelInstanceColor(
    'colors.fill.grey.primary',
    viewModelInstance,
  );

  useEffect(() => {
    if (viewModelInstance) {
      // eslint-disable-next-line local-rules/set-state-in-use-effect
      setCoinsValue(bonusValue);
      setDescription(bonusDescription);

      setBubblesColor(hexToRiveColorNumber(COLORS['Fill.Grey.Inactive'], 0.6));
      setCardColor(hexToRiveColorNumber(COLORS['Fill.Grey.Primary']));
    }
  }, [
    viewModelInstance,
    bonusValue,
    bonusDescription,
    setCoinsValue,
    setDescription,
    setBubblesColor,
    setCardColor,
  ]);

  return (
    <AnimationWrapper>
      <RiveComponent />
    </AnimationWrapper>
  );
};

const AnimationWrapper = styled.div`
  width: 200px;
  height: 150px;
`;
